(function () {
    function normalizeLetter(value) {
        return (value || '').trim().charAt(0).toUpperCase();
    }

    function initAllBrands(section) {
        var grid = section.querySelector('[data-brands-grid]');
        var buttons = section.querySelectorAll('[data-brand-filter]');
        var titleText = section.querySelector('[data-brands-title-text]');
        var countText = section.querySelector('[data-brands-count]');

        if (!grid || !buttons.length) {
            return;
        }

        var cards = Array.from(grid.querySelectorAll('[data-brand-card]'));

        // Sort brands alphabetically (A-Z)
        cards
            .sort(function (a, b) {
                return (a.dataset.brandName || '').localeCompare(
                    b.dataset.brandName || '',
                    'en',
                    {
                        sensitivity: 'base'
                    }
                );
            })
            .forEach(function (card) {
                grid.appendChild(card);
            });

        function setActive(button) {
            buttons.forEach(function (item) {
                var isActive = item === button;

                item.classList.toggle('is-active', isActive);
                item.setAttribute('aria-pressed', isActive ? 'true' : 'false');
            });
        }

        function updateTitle(title, visibleCount) {
            if (titleText) {
                titleText.textContent = title;
            }

            if (countText) {
                countText.textContent = '(' + visibleCount + ')';
            }
        }

        function filterCards(button) {
            var selectedLetter = button.dataset.brandFilter;
            var label = button.dataset.brandLabel || button.textContent.trim();
            var visibleCount = 0;

            cards.forEach(function (card) {
                var firstLetter = normalizeLetter(card.dataset.brandName);

                var shouldShow =
                    selectedLetter === 'all' ||
                    firstLetter === selectedLetter;

                card.hidden = !shouldShow;

                if (shouldShow) {
                    visibleCount++;
                }
            });

            setActive(button);

            if (selectedLetter === 'all') {
                updateTitle('All Brands', visibleCount);
            } else {
                updateTitle(label + ' Brands', visibleCount);
            }
        }

        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                filterCards(button);
            });
        });

        // Initialize with "View All"
        var defaultButton =
            section.querySelector('[data-brand-filter="all"]') || buttons[0];

        filterCards(defaultButton);
    }

    function initSections(root) {
        (root || document)
            .querySelectorAll('[data-metaobject-all-brands]')
            .forEach(function (section) {
                initAllBrands(section);
            });
    }

    document.addEventListener('DOMContentLoaded', function () {
        initSections(document);
    });

    document.addEventListener('shopify:section:load', function (event) {
        initSections(event.target);
    });
})();